import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=db3dcbe4&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=db3dcbe4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3dcbe4",
  null
  
)

export default component.exports